/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import CreateSourceModal from 'create-components/CreateSourceModal';
import {getOwnerChoices} from 'create-components/OwnableUtil';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';

interface Props {
  compact: boolean;
  openResult?: (...args: Array<any>) => any;
}

class NewProjectButton extends React.Component<Props> {
  _handleNewProject = (): void => {
    runModal(CreateSourceModal, {
      navigateOnSuccess: false,
      successCallback: this._handleOpenProject,
    });
  };

  _handleOpenProject = (folder: any): void => {
    this.props.openResult!({
      ...folder,
      // TODO(T2222): Remove when `folder.id` is always API ID.
      api_identifier: folder.id,
    });
  };

  override render(): JSX.Element {
    const disabled = getOwnerChoices().length === 0;

    return (
      <Tooltip
        title={disabled ? 'Please contact your administrator to create a project' : 'Create project'}
        placement={TooltipPlacement.BOTTOM}
        container="body"
      >
        <Button
          aria-label="Create project"
          aria-description={disabled ? 'Please contact your administrator to create a project' : undefined}
          buttonStyle={this.props.compact ? ButtonStyle.TERTIARY_BLUE : ButtonStyle.SECONDARY}
          icon="compose"
          disabled={disabled}
          onClick={this._handleNewProject}
          size={ButtonSize.SMALL}
          className="_test-new-project-button"
        />
      </Tooltip>
    );
  }
}

export default NewProjectButton;
